module.exports = __webpack_public_path__ + "static/media/photo_033.a030ccdd.JPG";